import React from "react";
import { X } from "lucide-react";

const InfoModal = ({ onClose }) => (
  <div className="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full p-6 relative">
    <button
      onClick={onClose}
      className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
    >
      <X className="h-6 w-6" />
    </button>
    <h2 className="text-2xl font-bold mb-4">About Komorebi (Alpha)</h2>
    <div className="space-y-4 text-sm">
      <p>
        Komorebi is a color palette generator created as a respectful homage to the work of Sanzo Wada
        (1883-1967), a Japanese artist, teacher, and color researcher. Wada's
        seminal work, "A Dictionary of Color Combinations," published in 1933,
        provides a unique perspective on color harmonies and nomenclature.
      </p>
      <p>
        This app is built with deep respect for Wada's legacy and is not intended to replicate or diminish his original work, but rather to honor and extend his color philosophy for modern digital design.
      </p>
      <p>
        In this implementation, the builder uses Wada's original color names as a base and
        extends them with modifiers to describe variations:
      </p>
      <ul className="list-disc list-inside">
        <li>"Nibi" (dull) for low saturation colors</li>
        <li>"Azayaka" (vivid) for high saturation colors</li>
        <li>"Kurai" (dark) for low lightness colors</li>
        <li>"Usui" (light) for medium-low lightness colors</li>
        <li>"Akarui" (bright) for high lightness colors</li>
      </ul>
      <p>
        To learn more about Sanzo Wada and his contributions to color theory,
        visit the
        <a
          href="https://en.wikipedia.org/wiki/Sanzo_Wada"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
        >
          {" "}
          Wikipedia page
        </a>
        .
      </p>
      <hr className="border-gray-200 dark:border-gray-700" />
      <div>
        <h3 className="font-semibold mb-2">Eye Dropper Tool</h3>
        <p className="mb-2">
          The eye dropper tool uses your browser's native color picker. Due to browser security restrictions:
        </p>
        <ul className="list-disc list-inside space-y-1 text-xs">
          <li>✅ Works on page content and images</li>
          <li>✅ Works on desktop/other apps (Chrome/Edge with permissions)</li>
          <li>❌ Cannot pick from browser UI (tabs, address bar, etc.)</li>
          <li>❌ Cannot pick from favicons</li>
          <li>❌ May not work on cross-origin content</li>
        </ul>
        <p className="mt-2 text-xs text-gray-600 dark:text-gray-400">
          Tip: The eye dropper works best on Chrome or Edge browsers.
        </p>
      </div>
    </div>
  </div>
);

export default InfoModal;